module.exports = "img {\n  max-width: 400px;\n  width: 100%;\n}\n"